export interface FilterOrSearchModel {
  nameOrId: string | null;
  searchAlias?: boolean | string | null;
  sortBy: 'recentArrestDate' | 'oldestArrestDate' | 'youngestAge' | 'oldestAge'
    | 'inmateName' | 'offenderPid' | 'offenderDoc' | 'location';
  arrestingAgencies: string[] | null;
  minAge: number | null;
  maxAge: number | null;
  minArrestDate: string | null;
  maxArrestDate: string | null;
  dateRange: LastNDays | null;
  offenderType?: string | null;
  docNumber?: string | null;
  pid?: string | null;
  supervisionStatus?: string | null;
  locationType?: string | null;
  facility?: string | null;
  countyOfSupervision?: string | null;
  gender?: string | null;
  race?: string | null;
  indictmentNumber?: string | null;
  crimeOrOffense?: string | null;
  revisedStatuteCode?: string | null;
  convictionCounty?: string | null;
  crimeDate?: string | null;
  convictionDate?: string | null;
  sentenceStartDate?: string | null;
  escapedDateStart?: string | null;
  escapedDateEnd?: string | null;
  projectedReleaseDateStart?: string | null;
  projectedReleaseDateEnd?: string | null;
}

export enum LastNDays {
  Custom = 0,
  Last7Days = -7,
  Last14Days = -14,
  Last30Days = -30
}